function initialiseFaqsSection( block ) {
	if ( block.dataset.faqsInitialised === 'true' ) {
		return;
	}

	block.dataset.faqsInitialised = 'true';

	block
		.querySelectorAll( '.alteia-faqs-section__item' )
		.forEach( ( item ) => {
			const toggle = item.querySelector(
				'.alteia-faqs-section__question-row'
			);
			const panel = item.querySelector( '.alteia-faqs-section__panel' );

			if ( ! toggle || ! panel ) {
				return;
			}

			toggle.addEventListener( 'click', () => {
				const isOpen =
					toggle.getAttribute( 'aria-expanded' ) === 'true';
				const willOpen = ! isOpen;

				item.classList.toggle( 'is-open', willOpen );
				toggle.setAttribute( 'aria-expanded', String( willOpen ) );
				panel.setAttribute( 'aria-hidden', String( ! willOpen ) );

				if ( willOpen ) {
					panel.removeAttribute( 'inert' );
				} else {
					panel.setAttribute( 'inert', '' );
				}
			} );
		} );
}

function initialiseAllFaqsSections() {
	document
		.querySelectorAll( '.wp-block-alteia-faqs-section' )
		.forEach( initialiseFaqsSection );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initialiseAllFaqsSections, {
		once: true,
	} );
} else {
	initialiseAllFaqsSections();
}
